import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";


export default function UiNavbarTopSelect(props) {
   
    const colorStyles = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#B1B5C3",
            };
        },
        ...(props.styles || {}),
    };

    return (
        <div className="sb-top-navbar-select-wr" >
            {props.selectDealer ? <label>Dealer</label> : props.selectQuarter ? <label>Quarter</label> : props.selectRole ? <label>Role</label> : <label>Area</label>}
                <Select
                    onChange={props.onChange}
                    className="sb-mobile-single"
                    classNamePrefix="select"
                    styles={colorStyles}
                    placeholder={props.placeholder}
                    options={props.options}
                    value={props.value}
                    defaultValue={props.defaultValue}
                    menuPortalTarget={props.menuPortalTarget}
                    menuPosition={props.menuPortalTarget ? "fixed" : undefined}
                />
        </div>
    );
}

UiNavbarTopSelect.propTypes = {
    label: PropTypes.string,
};
